module.exports = __webpack_public_path__ + "static/img/dkwps2-3.5977d26.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/dkwps2-3.png
// module id = 666
// module chunks = 0